// Character classes the parser and the writer agree on. Both must use these, or a body the editor
// writes could read back differently.

const SPACE = /\s/u;
const PUNCT = /[\p{P}\p{S}]/u;
const WORD = /[\p{L}\p{N}\p{M}]/u;
const ASCII_PUNCT = /[!-/:-@[-`{-~]/;

export const DELIMS = "*_~";

export function isSpace(ch: string | undefined): boolean {
  return ch !== undefined && SPACE.test(ch);
}

export function isWord(ch: string | undefined): boolean {
  return ch !== undefined && WORD.test(ch);
}

export function isAsciiPunct(ch: string | undefined): boolean {
  return ch !== undefined && ch.length === 1 && ASCII_PUNCT.test(ch);
}

/**
 * Whether a character next to a `*`, `_` or `~` lets it act as a mark: the edge of the text,
 * a space, or punctuation other than the same mark. A letter or digit does not, which keeps
 * 2*3*4 and snake_case_names as they are.
 */
export function isBoundary(ch: string | undefined, delim: string): boolean {
  if (ch === undefined) return true;
  if (ch === delim) return false;
  return SPACE.test(ch) || PUNCT.test(ch);
}

/** The whole character before index i, so an emoji made of two UTF-16 units counts as one. */
export function charBefore(s: string, i: number): string | undefined {
  if (i <= 0) return undefined;
  const low = s.charCodeAt(i - 1);
  if (low >= 0xdc00 && low <= 0xdfff && i >= 2) {
    const high = s.charCodeAt(i - 2);
    if (high >= 0xd800 && high <= 0xdbff) return s.slice(i - 2, i);
  }
  return s[i - 1];
}

/** The whole character starting at index i. */
export function charAt(s: string, i: number): string | undefined {
  if (i >= s.length) return undefined;
  const cp = s.codePointAt(i);
  return cp === undefined ? undefined : String.fromCodePoint(cp);
}
